import { render, staticRenderFns } from "./mediumdisplay.vue?vue&type=template&id=2c8586d3&"
import script from "./mediumdisplay.vue?vue&type=script&lang=js&"
export * from "./mediumdisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports